module.exports = __webpack_public_path__ + "img/pen.6e454c57.svg";